import { render, staticRenderFns } from "./BillingPackage.vue?vue&type=template&id=071887ff"
import script from "./BillingPackage.vue?vue&type=script&lang=ts"
export * from "./BillingPackage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports